import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
/* eslint-disable react/no-array-index-key */
import { List } from '@tribeplatform/react-ui-kit/Layout'

export const ConnectedAppRowLoading = ({ count = 5 }) => {
  return (
    <List spacing="none" divider>
      {[...Array(count)].map((_e, i) => (
        <List.Item key={i}>
          <div key={i} className="bg-surface p-2">
            <div className="animate-pulse flex space-s-4 items-center">
              <div className="rounded-base bg-skeleton h-12 w-12" />
              <div className="flex-1 space-y-4 py-1">
                <div className="h-4 bg-skeleton rounded-full w-3/4" />
              </div>
              <SvgIcon
                name="plus"
                size="lg"
                className="text-content-subdued transform transition-all ease-in-out duration-150"
              />
            </div>
          </div>
        </List.Item>
      ))}
    </List>
  )
}
